import React from "react";
import { Image } from "react-bootstrap";
import { Container, Row, Col, TabContent, TabPane } from "reactstrap";
import LoginForm from "./LoginForm";
import { Btn } from "../AbstractElements";
import { useNavigate } from "react-router-dom";

const Logins = () => {
  const navigate = useNavigate();
  const hotelLogo = localStorage.getItem('hotelLogo');

  return (
    <Container fluid={true} className="p-0">
      <Row>
        <Btn
          attrBtn={{
            color: 'primary',
            className: 'btn-block p-3',
            onClick: (e) => {
              localStorage.removeItem('hotelcode');
              localStorage.removeItem('hotelId');
              localStorage.removeItem('hotelLogo');
              setTimeout(() => {
                navigate("/");
              }, 1111)
            },
          }}
        >
          {"Change Hotel"}
        </Btn>
        <Col xs="12">
          <div className="login-card">
            <div>
              <div className="login-main1">
                <TabContent className="content-login">
                  <TabPane className="fade show d-flex d-flex flex-column align-items-center mb-3">
                    <Image
                      className="login-logo"
                      src={hotelLogo}
                      alt="Hotel Logo"
                    />
                  </TabPane>
                  <TabPane className="fade show">
                    <LoginForm />
                  </TabPane>
                </TabContent>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Logins;
